import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useInputStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            gap: 16,
            width: '100%',
            display: 'inline-flex',
            flexDirection: 'column'
        },
        label: {
            fontSize: 16,
            lineHeight: 1,
            fontWeight: 500,
            color: '#000000',
            fontFamily: 'Poppins'
        },
        labelError: {
            color: '#EF4F57'
        },
        input: {
            'fontSize': 16,
            'fontWeight': 400,
            'fontFamily': 'Poppins',

            'outline': 0,
            'width': '100%',
            'borderRadius': 70,
            'padding': '12.5px 30px',
            'border': 'solid 1px #E5E5E5',

            '&:focus': {
                borderColor: '#000000'
            },

            '&[type="number"]': {
                '-moz-appearance': 'textfield',

                '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                    '-webkit-appearance': 'none',
                    'margin': 0
                }
            }
        },
        inputFilled: {
            borderColor: '#000000'
        },
        inputError: {
            borderColor: '#EF4F57'
        },

        small: {
            fontSize: 15,
            padding: '9.5px 20px'
        }
    })
);
